import { render, staticRenderFns } from "./UserSocialSelfiesData.vue?vue&type=template&id=2f06e722&"
import script from "./UserSocialSelfiesData.vue?vue&type=script&lang=js&"
export * from "./UserSocialSelfiesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports